import { useState } from 'react'

import { createId } from '@paralleldrive/cuid2'
import { RcFile } from 'antd/lib/upload'
import html2canvas from 'html2canvas'

export const useScreenshotCapture = () => {
  const [isCapturing, setIsCapturing] = useState(false)

  const captureScreenshot = async (): Promise<RcFile | null> => {
    try {
      setIsCapturing(true)

      if (typeof window === 'undefined') return null

      const canvas = await html2canvas(document.documentElement, {
        useCORS: true,
        logging: false,
        scale: window.devicePixelRatio,
        windowWidth: document.documentElement.scrollWidth,
        windowHeight: document.documentElement.scrollHeight,
      })

      // Convert canvas to blob
      const blob = await new Promise<Blob>((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (blob) resolve(blob)
          else reject(new Error('Failed to create blob'))
        }, 'image/png')
      })

      // Create file object
      const file = new File([blob], `screenshot-${Date.now()}.png`, {
        type: 'image/png',
      }) as RcFile

      // Add uid to make it compatible with uploader
      file.uid = createId()

      return file
    } catch (error) {
      console.error('Screenshot failed:', error)
      return null
    } finally {
      setIsCapturing(false)
    }
  }

  return {
    isCapturing,
    captureScreenshot,
  }
}
